import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
export const config = {
    value: 'componentReload',
    position: ALL_BUTTON_POSITION_LIST,
    action: (arg) => {
        const { buttonConfig, _context } = arg || {};
        const { options = {} } = buttonConfig;
        const { _bindComponent } = options;
        function reloadOneComponent(id) {
            if (typeof id === 'string') {
                const com = _context.$(id);
                com?.load?.();
            }
        }
        if (_bindComponent && _context) {
            if (Array.isArray(_bindComponent)) {
                _bindComponent.forEach((item) => {
                    reloadOneComponent(item);
                });
            }
            else {
                reloadOneComponent(_bindComponent);
            }
        }
    },
};
